import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { UserPreferencesData } from "src/mockup/UserPreferencesData";

export const postUserPreferences = async (accessToken: string, data: UserPreferencesData, signal?: AbortSignal): Promise<UserPreferencesData> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/preferences`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Cache-Control": "no-cache",
      },
      body: JSON.stringify(data),
      signal,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Failed to save preferences: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Preferences request was aborted");
      return;
    }
    showErrorToast("Something went wrong when saving user preferences");
    throw error;
  }
};
